import React from "react";

// components

// import { Table, TableProps, Popconfirm } from "antd";

import EditCategory from "../misc/EditCategory";
import CreateCategory from "../misc/CreateCategory";
import { ColumnDef } from "@tanstack/react-table";

// constants and icon
import { FaPlus, FaArrowLeftLong } from "react-icons/fa6";
// import { FaTrash, FaEdit } from "react-icons/fa"

// router and dispatch
import { get_categories, delete_category } from "../../../services/apis/blog";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store";
import ItemAction from "../../../component/ui/action/ItemAction";
import DataTable from "../../../component/element/table";
import { ICategory } from "../../../store/types/blog";
import Button from "../../../component/element/forms/Button";

const BlogCategory = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const categories = useAppSelector(({ blog }) => blog.categories);

  const [show, showSet] = React.useState<boolean>(false);
  const [edit, editSet] = React.useState<{
    show: boolean;
    data: ICategory | null;
  }>({
    show: false,
    data: null,
  });

  const onLoad = React.useCallback(() => {
    get_categories(dispatch);
  }, [dispatch]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  const columns: ColumnDef<ICategory>[] = [
    {
      accessorKey: "name",
      header: "Name",
    },
    {
      accessorKey: "id",
      header: "Action",
      cell: ({ getValue, row: { original: data } }) => {
        const id = getValue() as string;
        return (
          <ItemAction
            show_view={false}
            onEdit={() => {
              editSet({ show: true, data });
            }}
            onView={() => null}
            onDelete={() => delete_category(id, dispatch)}
          />
        );
      },
    },
  ];

  return (
    <div className="w-full">
      <div className="w-full flex justify-between items-center px-2 py-1">
        <h2 className="font-bold text-xl capitalize mb-0">Category</h2>

        <div className="flex items-center space-x-3 justify-end ">
          <Button
            title="Create"
            children={<FaPlus className="mr-2" />}
            onClick={() => showSet(true)}
            className="w-32 text-white"
          />

          <Button
            title="Back"
            children={<FaArrowLeftLong className="mr-2" />}
            onClick={() => navigate(-1)}
            className="w-32 text-white"
          />
        </div>
      </div>

      <div className="mt-[20px] flex flex-1 flex-col ">
        <DataTable columns={columns} data={categories} />
      </div>

      <CreateCategory show={show} onModal={() => showSet(false)} />

      {edit.data !== null && (
        <EditCategory
          data={edit.data}
          show={edit.show}
          onHandler={() => editSet({ show: false, data: null })}
        />
      )}
    </div>
  );
};

export default BlogCategory;
